module.exports = __webpack_public_path__ + "static/media/minus_icon.8f893bb2.svg";